import ThemeOptions from "./ThemeOptions";
import AuthSlice from '../store/AuthSlice.tsx';
import { combineReducers } from 'redux';

const reducer = combineReducers({
  ThemeOptions,
  auth : AuthSlice,
});

export default reducer;
